/**
 * `AW11` — el borde de exportación, disponible para el árbol.
 *
 * Mismo patrón que `contexto-borde-envios.tsx` y por la misma razón de fondo:
 * la pantalla de exportación lo necesita y está a varios niveles de la raíz, así
 * que la alternativa es plomería por props a través del montaje.
 *
 * Hay una segunda razón, y es la que importa: **inyectado, el borde se puede
 * reemplazar por un doble.** La pantalla se puede ejercer contra un doble en
 * memoria, sin base, sin red y sin el módulo real — y eso sólo es posible si el
 * borde entra por afuera. Un `crearBordeExportacionHttp()` llamado adentro del
 * componente haría que la única forma de probarlo fuera interceptar `fetch`,
 * que es probar el transporte en vez de la pantalla.
 */

import { createContext, useContext } from "react"
import type { BordeExportacion } from "./exportacion/borde-exportacion.ts"

/**
 * Sin valor por defecto, igual que los otros contextos de borde.
 *
 * Un doble por defecto acá haría que un componente montado fuera del proveedor
 * anduviera igual, escribiendo en el aire. Falla en el primer render.
 */
const ContextoBordeExportacion = createContext<BordeExportacion | null>(null)

export const ProveedorBordeExportacion = ContextoBordeExportacion.Provider

export function useBordeExportacion(): BordeExportacion {
  const borde = useContext(ContextoBordeExportacion)
  if (borde === null) {
    throw new Error(
      "useBordeExportacion() se llamó fuera de <ProveedorBordeExportacion>. El borde se arma en App.tsx con la configuración ya leída.",
    )
  }
  return borde
}
